// start:ng42.barrel
export * from './new-acopio-dialog';
export * from './new-categoria-dialog';
export * from './abm';
export * from './abmacopios-filter';
export * from './abmcategorias-filter';
export * from './abmroles-filter';
export * from './acopio-detail';
export * from './categoria-detail';
export * from './rol-detail';
export * from './new-edit-producto-dialog';
export * from './colaboradores';
export * from './permisos-list';
export * from './permisos-detail';
export * from './mercado';
export * from './entidades-financieras';
export * from './edit-acopio-dialog'



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/index.ts